import { BusinessObjectBase } from './base';
import type { Organization } from './organization';

export interface OrgStructureLevelData {
  readonly id: string;
  readonly name?: string;
  readonly description?: string;
  readonly organizations?: Organization[];
}

export interface OrgStructureLevel extends Readonly<OrgStructureLevelData> {}
export class OrgStructureLevel extends BusinessObjectBase {
  static readonly entityName = 'OrgStructureLevel' as const;
  static readonly plural = 'org-structure-levels';

  // --- Static CRUD methods ---

  static async find(filter?: any): Promise<OrgStructureLevel[]> {
    const url = `${this.baseUrl}/${this.plural}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const results = await this.get<any[]>(url, params);
    return results.map((data) => new OrgStructureLevel(data));
  }

  static async findOne(filter?: any): Promise<OrgStructureLevel | null> {
    const url = `${this.baseUrl}/${this.plural}/find-one`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return data ? new OrgStructureLevel(data) : null;
  }

  static async findById(id: string, filter?: any): Promise<OrgStructureLevel> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return new OrgStructureLevel(data);
  }

  static async create(
    data: Omit<OrgStructureLevelData, 'id'>,
  ): Promise<OrgStructureLevel> {
    const url = `${this.baseUrl}/${this.plural}`;
    const result = await this.post<any>(url, data);
    return new OrgStructureLevel(result);
  }

  static async updateById(
    id: string,
    data: Partial<OrgStructureLevelData>,
  ): Promise<OrgStructureLevel> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const result = await this.patch<any>(url, data);
    return new OrgStructureLevel(result);
  }

  static async deleteById(id: string): Promise<boolean> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    try {
      await this.del<void>(url);
      return true;
    } catch {
      return false;
    }
  }
}
